<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="disabled" [multiple]="multiple"
           [placeholder]="'hx.brand-select.selectBrand' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.id">{{op.title}}</ng-option>
</ng-select>
